const initValues = {
  id: 0,
};

export const layoutReducer = (state = initValues, { type, payload }: any) => {
  switch (type) {
    case 'CHANGE_ACCORDION':
      state = {
        ...state,
        id: payload,
      };
      break;
  }

  return state;
};
